import * as Sentry from '@sentry/react';
import { LiveUpdate } from '@capawesome/capacitor-live-update';
import { isNative } from './platform';

/**
 * Confirm to the Live Update plugin that the running bundle booted. Without it, the plugin reverts
 * a freshly applied bundle to the one shipped in the binary once `readyTimeout` expires, so it is
 * called from the app shell's mount: a bundle that cannot render that far gets rolled back.
 */
export const markLiveUpdateReady = () => {
    if (!isNative()) return;

    LiveUpdate.ready().catch((error: unknown) => {
        Sentry.captureException(error);
    });
};
